import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import {
  Building2, Database, Ruler, Factory, Cpu, Server, Wallet, MapPin, Target,
} from "lucide-react";
import { cn } from "../../lib/utils";

const SUBNAV = [
  { to: "/admin/organisation",   label: "Organisation Settings", icon: Building2 },
  { to: "/admin/entities",       label: "Companies & Sites",     icon: MapPin    },
  { to: "/admin/kpi-ownership",  label: "KPI Ownership & Targets", icon: Target  },
  { to: "/admin/database",       label: "Database Manager",     icon: Database  },
  { to: "/admin/units",          label: "ESG Units Conversion", icon: Ruler     },
  { to: "/admin/factors",        label: "Factor Libraries",     icon: Factory   },
  { to: "/admin/ai-usage",       label: "AI Usage Monitor",     icon: Cpu       },
  { to: "/admin/infra",          label: "Infra Cost Monitor",   icon: Server    },
  { to: "/admin/quotas",         label: "Cost Alerts & Quotas", icon: Wallet    },
];

export default function AdminShell() {
  return (
    <div className="flex min-h-full">
      <aside className="w-[240px] shrink-0 border-r border-border bg-surface" data-testid="admin-subnav">
        <div className="px-4 py-4 border-b border-border">
          <div className="section-label">Admin</div>
          <div className="text-sm font-semibold mt-1">Tenant Configuration</div>
        </div>
        <nav className="p-2 space-y-1">
          {SUBNAV.map(n => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to} to={n.to}
                data-testid={`admin-nav-${n.label.toLowerCase().replace(/[^a-z]+/g, '-')}`}
                className={({isActive}) => cn("nav-link", isActive && "active")}
              >
                <Icon size={14}/> <span className="truncate">{n.label}</span>
              </NavLink>
            );
          })}
        </nav>
      </aside>
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
